import { AfterViewInit, OnDestroy } from '@angular/core';
var CustomLoadingRendererComponent = /** @class */ (function () {
    function CustomLoadingRendererComponent(document) {
        this.document = document;
        this.pageSize = 0;
        this.classNamePrefix = 'ag-grid-page-per_';
        this.show = false;
    }
    CustomLoadingRendererComponent.prototype.afterGuiAttached = function (params) {
    };
    CustomLoadingRendererComponent.prototype.agInit = function (params) {
        this.document.body.classList.add('cs-ag-grid-loading-enabled');
        params['paginationPageSize'] = params.api.paginationGetPageSize();
        var oldClassName = this.classNamePrefix + this.pageSize;
        if (this.pageSize > 0) {
            this.document.body.classList.remove(oldClassName);
        }
        this.pageSize = params['paginationPageSize'];
        this.document.body.classList.add(this.classNamePrefix + this.pageSize);
        var generateStep = function (start, stop, step) {
            if (stop == null) {
                stop = start || 0;
                start = 0;
            }
            if (!step) {
                step = stop < start ? -1 : 1;
            }
            var length = Math.max(Math.ceil((stop - start) / step), 0);
            var range = Array(length);
            for (var idx = 0; idx < length; idx++, start += step) {
                range[idx] = start;
            }
            return range;
        };
        this.rows = generateStep(0, params['paginationPageSize'], 1);
        this.params = params;
    };
    CustomLoadingRendererComponent.prototype.ngOnDestroy = function () {
        this.document.body.classList.remove(this.classNamePrefix + this.pageSize);
        this.document.body.classList.remove('cs-ag-grid-loading-enabled');
    };
    CustomLoadingRendererComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.show = true;
        }, 100);
    };
    return CustomLoadingRendererComponent;
}());
export { CustomLoadingRendererComponent };
